import React, { useState, useEffect, useContext } from "react";
import clsx from "clsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    Divider,
    IconButton,
    Container,
    Popover,
    ListItem,
    List,
    ListItemText,
    ListItemIcon,
} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AppsIcon from "@mui/icons-material/Apps";
import HandshakeIcon from "@mui/icons-material/Handshake";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

import { Link, useNavigate } from "react-router-dom";
import {
    ExitToAppTwoTone,
    AccountCircle,
    Settings,
} from "@material-ui/icons";

import AuthService from "../services/AuthService";
import NotificationService from "../services/NotificationService";
import PartnerService from "../services/PartnerService";

import partnerUseStyles from "./main.partner.styles";
import { Box, Button } from "@mui/material";

import ImportDialog from "../screens/Partner/Import/ImportDialog";
import SynchronizeDialog from "../screens/Partner/Import/SynchronizeDialog";

import { userDetailContext } from "../App";
import FormationSideBartreeView from "./FormationSideBartreeView";
import ModeList from "./ModeList";

function ListItemLink(props) {
    return <ListItem button component={Link} {...props} />;
}

const FormationMainContainer = (props) => {

    const classes = partnerUseStyles();
    const contextData = useContext(userDetailContext);
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);
    const [numberOfNotification, setNumberOfNotification] = useState(0);

    const [notificationUserSubId, setUserSubNotificationId] = useState([]);
    const [notificationUserSupId, setnotificationUserSupId] = useState([]);

    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [synchronizeDialogOpen, setSynchronizeDialogOpen] = useState(false);
    const [unSyncedPeriods, setUnSyncedPeriods] = useState([]);

    const [modePopoverAnchorEl, setModePopoverAnchorEl] = useState(null);
    const [accountPopoverAnchorEl, setAccountPopoverAnchorEl] = useState(null);

    // Notifications
    function loadNotification() {
        NotificationService.getstatus().then((result) => {
            if (result && result.data) {
                setUserSubNotificationId(result.notification_id || []);
            }
        });
    }

    function loadUserSuperiorNotification() {
        NotificationService.getUserSupNotification().then((result) => {
            if (result && result.data) {
                setnotificationUserSupId(result.notification_id || []);
            }
        });
    }

    async function getUnSyncedPeriods() {
        try {
            const result = await PartnerService.unsyncedPeriods();
            setUnSyncedPeriods(result?.data || []);
        } catch (error) {
            console.error(error);
            setUnSyncedPeriods([]);
        }
    }

    useEffect(() => {
        loadNotification();
        loadUserSuperiorNotification();
        getUnSyncedPeriods();
    }, []);

    useEffect(() => {
        setNumberOfNotification(
            notificationUserSubId.length + notificationUserSupId.length
        );
    }, [notificationUserSubId, notificationUserSupId]);

    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);

    const handleClickLogout = () => {
        AuthService.logout();
    };

    const handleSynchronizePeriods = async (periodIds) => {
        await PartnerService.synchronizePeriods(periodIds);
        getUnSyncedPeriods();
    };

    const modePopoverOpen = Boolean(modePopoverAnchorEl);
    const accountPopoverOpen = Boolean(accountPopoverAnchorEl);

    return (
        <div className={classes.root}>
            <CssBaseline />

            <AppBar
                position="absolute"
                className={clsx(classes.appBar, open && classes.appBarShift)}
            >
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleDrawerOpen}
                        className={clsx(
                            classes.menuButton,
                            open && classes.menuButtonHidden
                        )}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography component="h3" variant="h6" color="inherit">
                        {props.title}
                    </Typography>

                    <div className={classes.expand}></div>

                    {/* Mode */}
                    <Box sx={{ display: { xs: "none", sm: "block" }, mr: 6 }}>
                        <Button
                            color="inherit"
                            onClick={(e) => setModePopoverAnchorEl(e.currentTarget)}
                            endIcon={<ExpandMoreIcon />}
                        >
                           Espace Tutoriels
                        </Button>

                        <Popover
                            open={modePopoverOpen}
                            anchorEl={modePopoverAnchorEl}
                            onClose={() => setModePopoverAnchorEl(null)}
                        >
                            <ModeList onSelectMode={(selectedMode) => {
                                setModePopoverAnchorEl(null);
                                navigate(selectedMode.link);
                            }} />
                        </Popover>
                    </Box>

                    {/* Paramètres */}
                    <IconButton
                        color="inherit"
                        onClick={(e) => setAccountPopoverAnchorEl(e.currentTarget)}
                    >
                        <Settings />
                    </IconButton>

                    <Popover
                        open={accountPopoverOpen}
                        anchorEl={accountPopoverAnchorEl}
                        onClose={() => setAccountPopoverAnchorEl(null)}
                    >
                        <List>
                            <ListItemLink to="/myAccount">
                                <ListItemIcon><AccountCircle /></ListItemIcon>
                                <ListItemText primary="Mon compte" />
                            </ListItemLink>

                            <ListItemLink to="/partner/guide">
                                <ListItemIcon><MenuBookIcon /></ListItemIcon>
                                <ListItemText primary="Guide utilisateur" />
                            </ListItemLink>

                            <ListItemLink to="/" onClick={handleClickLogout}>
                                <ListItemIcon><ExitToAppTwoTone /></ListItemIcon>
                                <ListItemText primary="Déconnexion" />
                            </ListItemLink>
                        </List>
                    </Popover>
                </Toolbar>
            </AppBar>

            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <div className={classes.logo} link="/home"></div>
                    <IconButton onClick={handleDrawerClose}>
                        <MenuIcon />
                    </IconButton>
                </div>
                <Divider />
                <FormationSideBartreeView />
            </Drawer>

            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth={false} disableGutters>
                    {props.children}
                </Container>
            </main>

            <ImportDialog
                openDialog={importDialogOpen}
                onClose={() => {
                    setImportDialogOpen(false);
                    getUnSyncedPeriods();
                }}
            />

            <SynchronizeDialog
                open={synchronizeDialogOpen}
                onClose={() => setSynchronizeDialogOpen(false)}
                unsyncedPeriods={unSyncedPeriods}
                onSynchronize={handleSynchronizePeriods}
            />
        </div>
    );
};

export default FormationMainContainer;